import styled from "styled-components";
import { device } from "./Device";
import arrowDown from "../asset/pictures/arrow1.svg";

const AccordionSection = styled.div`
  ${"" /* width: 100%;
  max-width: 768px;
  margin: 0 auto;
  padding: 23px; */}
`;
const AccordionContainer = styled.div`
  width: 100%;
  visibility: ${(props) => props.visibility};
  overflow: hidden; /* masque tout ce qui dépasse */
`;

const AccordionTitle = styled.div`
  position: relative;
  font-size: 20px;
  padding-right: 53px;
  transition: all 0.4s ease;
  margin-bottom: ${(props) => (props.isOpen ? "15px" : "0")};
  cursor: pointer;

  &::after {
    content: url(${arrowDown});
    position: absolute;
    top: 50%;
    right: 0px;
    transform: translateY(-50%);
    transition: all 0.4s ease;
    margin-right: 12px;
    width: 30px;
    height: 30px;
    transform: ${(props) =>
      props.isOpen ? "translateY(-50%) rotate(180deg)" : ""};
  }

  @media ${device.tablet} {
    padding-right: 30px;
    &::after {
      width: 17px;
      height: 17px;
      right: -6px;
    }
  }
`;
const AccordionContent = styled.div`
  opacity: ${(props) => (props.isOpen ? "1" : "0")};
  max-height: ${(props) => (props.isOpen ? "1000px" : "0")};
  overflow-y: hidden;
  transition: all 0.4s ease;
  flex-basis: ${(props) => props.flexBasis};
  background-color: ${(props) => props.backgroundColor};
`;

export {
  AccordionSection,
  AccordionContainer,
  AccordionTitle,
  AccordionContent,
};
